export const PROPERTY_PREFIX = 'jsonPath.';
export const PERMISSIONS = '$permissions.';
